// extracted by mini-css-extract-plugin
export default {"info_box":"index_info_box_-CuH3 clearfix","comment":"index_comment_3PWgw","pic":"index_pic_-HXy4","v_logo":"index_v_logo_DO1K9","text":"index_text_DtRw5","time":"index_time_shuph"};